import http from '@/utils/http'

/********************TOB***********************/ 
/**
 * TOB主体分页列表  
*/
// export function getTobList(data) {
//     return http({
//         url: '/system/xcwsEntity/paging',
//         method: 'post',
//         data
//     })
// }

/**
 * 主体汇总分页列表  
*/
// export function getSchoolList(data) {
//     return http({
//         url: '/system/xcwsEntity/school/paging',
//         method: 'post',
//         data
//     })
// }

/**
 * 同步主体
*/
// export function subSync(params) {
//     return http({
//         url: '/system/xcwsEntity/entitySync',
//         method: 'get',
//         params
//     })
// }

/**
 * 获取区域列表
*/
export function getAreaList(params) {
  return http({
      url: '/system/xcwsEntity/getAreaList',
      method: 'get',
      params
  })
}

/**
 * 主体启用禁用
*/
export function availableUpdate(data) {
    return http({
        url: '/system/xcwsEntity/school/available/update?entityId='+data.entityId+'&available='+data.available,
        method: 'post'
    })
}

/**
 * 主体批量启用
*/
export function batchEnable(data) {
  return http({
      url: '/system/xcwsEntity/school/batchEnable?entityIds=' + data,
      method: 'post'
  })
}

/**
 * 主体批量禁用
*/
export function batchDisable(data) {
  return http({
      url: '/system/xcwsEntity/school/batchDisable?entityIds=' + data,
      method: 'post'
  })
}

/**
 * 行业类型修改
*/
export function subTypeUpdate(params) {
  return http({
      url: '/system//xcwsEntity/update',
      method: 'POST',
      params
  })
}

/********************TOG***********************/ 

/**
 * TOG区域列表
*/
// export function getTogAreaList(params) {
//     return http({
//         url: '/system/xcwsEntity/TogArea/paging',
//         method: 'get',
//         params
//     })
// }

/**
 * TOG主体绑定
*/
// export function bindTogSub(data) {
//     return http({
//         url: '/system/xcwsEntity/togEntityBind',
//         method: 'post',
//         data
//     })
// }

/**
 * TOG主体解绑
*/
// export function unboundTogSub(data) {
//     return http({
//         url: '/system/xcwsEntity/togEntityUntied',
//         method: 'post',
//         data
//     })
// }


/****************** new api *********************/
/**
* 文件上传,返回url
*/
export function uploadGetUrl(data) {
  return http({
      url: '/common/file/upload/sysadmin/url',
      method: 'post',
      data
  })
}

/**
 * TOB区域列表
*/
export function tobAreaList(params) {
  return http({
      url: '/tob/tsysArea/list',
      method: 'get',
      params
  })
}

/**
 * TOB区域树
*/
export function tobAreaTree(params) {
  return http({
      url: '/tob/tsysArea/tree',
      method: 'get',
      params
  })
}

/**
 * 管理员账号是否存在
*/
export function isAdminExist(params) {
  return http({
      url: '/system/xcwsEntity/checkAccount',
      method: 'get',
      params
  })
}

/**
 * TOB待绑定主体列表
*/
export function tobExpectBindSub(params) {
  return http({
      url: '/tob/tbyBuyer/paging',
      method: 'get',
      params
  })
}

/**
* 主体管理-分页列表
*/
export function subjectList(data) {
  return http({
      url: '/system/xcwsEntity/paging',
      method: 'post',
      data
  })
}

/**
* 主体管理-TOB主体批量添加
*/
export function tobSubBatchAdd(data) {
  return http({
      url: '/system/xcwsEntity/addBatchTOB',
      method: 'post',
      data
  })
}

/**
* 主体管理-TOG主体批量添加
*/
export function togSubBatchAdd(data) {
  return http({
      url: '/system/xcwsEntity/addBatchTOG',
      method: 'post',
      data
  })
}


/**
* 主体管理-主体添加
*/
export function subjectAdd(data) {
  return http({
      url: '/system/xcwsEntity/addV2',
      method: 'post',
      data
  })
}

/**
* 主体管理-主体详情
*/
export function subjectDetail(params) {
  return http({
      url: '/system/xcwsEntity/findV2',
      method: 'get',
      params
  })
}

/**
* 主体管理-主体修改
*/
export function subjectUpdate(data) {
  return http({
      // url: '/system/xcwsEntity/update',
      url: '/system/xcwsEntity/updateInfoV2',
      method: 'post',
      data
  })
}

/**
* 主体管理-主体管理员密码修改
*/
export function pwdUpdate(data) {
  return http({
      url: '/system/xcwsEntity/updatePassword',
      method: 'post',
      data
  })
}

/**
* 同步绑定-分页列表
*/
export function subjectBindList(data) {
  return http({
      url: '/system/xcwsEntity/bind/paging',
      method: 'post',
      data
  })
}



/**
* 主体绑定-TOG区域列表
*/
export function togAreaList(params) {
  return http({
      url: '/system/entityBind/TogArea/paging',
      method: 'get',
      params
  })
}

/**
* 主体绑定-TOG主体列表
*/
export function togSubList(params) {
  return http({
      url: '/system/entityBind/togEntity/paging',
      method: 'get',
      params
  })
}

/**
* 主体绑定-绑定TOG主体
*/
export function togSubBind(data) {
  return http({
      url: '/system/entityBind/togEntityBind',
      method: 'post',
      params: data
  })
}

/**
* 主体绑定-解绑TOG主体
*/
export function togSubUnbind(data) {
  return http({
      url: '/system/entityBind/togEntityUntied',
      method: 'post',
      params: data
  })
}

/**
 * TOB主体增量同步
*/
export function incrSync() {
    return http({
        url: '/tob/datasync/entity/incrSyncJob',
        method: 'get'
    })
}



/**
 * TOG区域树
*/
export function togAreaTree(params) {
  return http({
      url: '/tog/entity/area/tree',
      method: 'get',
      params
  })
}

/**
 * TOG主体列表
*/
export function togToBindSubList(params) {
  return http({
      url: '/tog/entity/paging',
      method: 'get',
      params
  })
}

/**
 * TOG系统下拉列表
*/
export function togSysList() {
  return http({
      url: '/tog/entity/system/option/list',
      method: 'get'
  })
}

/**
 * 二维码
*/
export function xcwsEntityQrcode(data) {
  return http({
      url: '/system/xcwsEntityQrcode/find',
      method: 'GET',
      params:data
  })
}

/**
 * TOG导入校餐卫士三小主体列表
*/
export function getCfdaOfTogEntity(params) {
  return http({
      url: '/system/entityBind/togEntity/import/cfda/paging',
      method: 'get',
      params
  })
}

/**
 * TOG导入校餐卫士一般主体列表
*/
export function getSubOfTogEntity(params) {
  return http({
      url: '/system/entityBind/togEntity/import/sub/paging',
      method: 'get',
      params
  })
}

/**
 * 批量导出公示牌
*/
export function exportBrand(data) {
  return http({
      url: '/dzsd/review/import/public/brand',
      method: 'post',
      data
  })
}